export default axiosInstance => {
  async function change({ jwt, current }) {
    return (
      await axiosInstance({
        method: "patch",
        url: "/liff/user",
        headers: { jwt },
        data: { current }
      })
    ).data;
  }

  /** 會員綁定 */
  async function bind({ jwt, form }) {
    return (
      await axiosInstance({
        method: "put",
        url: "/liff/member",
        headers: { jwt },
        data: { form }
      })
    ).data;
  }

  /** 會員簡訊驗證 */
  async function verify({ jwt, form }) {
    return (
      await axiosInstance({
        method: "patch",
        url: "/liff/member",
        headers: { jwt },
        data: { form }
      })
    ).data;
  }

  return {
    change,
    bind,
    verify
  };
};
